import {
  LayerType,
  GetIngredients,
  getNewId,
  isNullOrUndefined,
  GetIngredientTypeColors,
  getHexColor,
  getIngredientIngredientTypeByIngIngTypeIdDict,
  getIngredientTypeByIngTypeIdDict,
} from 'utils/Global';
import { GetPlate, isOverlappingLayer } from 'business/plateviewer/GenerateUtil';
import {
  LayerClient,
  SeedLayerDTO,
  TargetLayer,
  TargetLayerIngredient,
  WellDropLayer,
} from 'business/models/CustomModels';
import {
  DropDTO,
  DropLayerDTO,
  FragmentLayerDTO,
  IngredientDTO,
  IngredientIngredientTypeDTO,
  IngredientStockDTO,
  IngredientTypeColor,
  IngredientTypeDTO,
  LayerDTO,
  LayerStateDTO,
  LayerTypeDTO,
  ProteinLayerDTO,
  RandomLayerDTO,
  ScreenLayerDTO,
  WellIngDTO,
  WellLayerDTO,
  WellLayerIngredientDTO,
} from 'business/models/Models';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import PlateDtoClient from 'business/models/PlateDtoClient';
import { CustomLayerGenerate } from './CustomLayerGenerate';
import { countDecimals, GridLayerGenerate } from './GridLayerGenerate';
import { computeWellsVol } from './VolCalculator';
import { RandomLayerGenerate } from './RandomLayerGenerate';
import { ScreenLayerGenerate } from './ScreenLayerGenerate';
import { SeedLayerGenerate } from './SeedLayerGenerate';
import { ProteinLayerGenerate } from './ProteinLayerGenerate';
import { DrawingLayer } from 'business/models/DrawingLayer';
import { FragmentLayerGenerate } from './FragmentLayerGenerate';
import {
  Drop,
  DropLayer,
  Plate,
  PlateIngredient,
  WellIng,
  WellLayer,
} from 'components/Experiment/constants';

//setMaxVolume
export function setMaxVolume(ing: PlateIngredient, containerMaxWellVolume: number) {
  let max = 0;
  if (isNullOrUndefined(ing) || isNullOrUndefined(ing.wellList)) {
    return;
  }

  ing.wellList.forEach((well) => {
    if (well.wellVolume > max) {
      if (well.wellVolume <= containerMaxWellVolume) {
        max = well.wellVolume;
      }
    }
  });
  ing.maxWellVolume = max;
}

export function copyWelllayerIngredients(
  targetLayerIngredient: TargetLayerIngredient,
  sourceWellLayerIngredient: WellLayerIngredientDTO,
) {
  targetLayerIngredient.volume = sourceWellLayerIngredient.volume;
  targetLayerIngredient.ingredientTypeIsBuffer =
    sourceWellLayerIngredient.ingredientTypeIsBuffer;
  targetLayerIngredient.color = sourceWellLayerIngredient.color;
  targetLayerIngredient.hexColor = sourceWellLayerIngredient.hexColor;
  targetLayerIngredient.lowPHVolume = sourceWellLayerIngredient.lowPHVolume;
  targetLayerIngredient.highPHVolume = sourceWellLayerIngredient.highPHVolume;

  targetLayerIngredient.ingredientIngredientTypeId =
    sourceWellLayerIngredient.ingredientIngredientTypeId;
  targetLayerIngredient.ingredientStockIngredient =
    sourceWellLayerIngredient.ingredientStockIngredient;

  targetLayerIngredient.ingredientIngredientTypeIsBuffer =
    sourceWellLayerIngredient.ingredientIngredientTypeIsBuffer;

  targetLayerIngredient.ingredientTypeId = sourceWellLayerIngredient.ingredientTypeId;

  targetLayerIngredient.ingredientTypeName = sourceWellLayerIngredient.ingredientTypeName;
  targetLayerIngredient.ingredientStockIngredient =
    sourceWellLayerIngredient.ingredientStockIngredient;
  targetLayerIngredient.ingredientStockId = sourceWellLayerIngredient.ingredientStockId;
  targetLayerIngredient.ingredientStock = sourceWellLayerIngredient.ingredientStock;
  targetLayerIngredient.highPhIngStock = sourceWellLayerIngredient.highPhIngStock;

  targetLayerIngredient.ingredientTypeColorGroupId =
    sourceWellLayerIngredient.ingredientTypeColorGroupId;

  targetLayerIngredient.concentration = sourceWellLayerIngredient.concentration;
  targetLayerIngredient.preMixedConcentration =
    sourceWellLayerIngredient.preMixedConcentration;
  targetLayerIngredient.pH = sourceWellLayerIngredient.pH;

  targetLayerIngredient.highPhIngStockId = sourceWellLayerIngredient.highPhIngStockId;
  targetLayerIngredient.highPhIngStock = sourceWellLayerIngredient.highPhIngStock;

  targetLayerIngredient.stockConcentration = sourceWellLayerIngredient.stockConcentration;
  targetLayerIngredient.isBuffer = sourceWellLayerIngredient.isBuffer;
}

export function copyTargetlayerIngredients(
  targetLayerIngredient: TargetLayerIngredient,
  sourceWellLayerIngredient: TargetLayerIngredient,
) {
  targetLayerIngredient.volume = sourceWellLayerIngredient.volume;
  targetLayerIngredient.ingredientTypeIsBuffer =
    sourceWellLayerIngredient.ingredientTypeIsBuffer;
  targetLayerIngredient.color = sourceWellLayerIngredient.color;
  targetLayerIngredient.hexColor = sourceWellLayerIngredient.hexColor;
  targetLayerIngredient.lowPHVolume = sourceWellLayerIngredient.lowPHVolume;
  targetLayerIngredient.highPHVolume = sourceWellLayerIngredient.highPHVolume;

  targetLayerIngredient.ingredientIngredientTypeId =
    sourceWellLayerIngredient.ingredientIngredientTypeId;
  targetLayerIngredient.ingredientStockIngredient =
    sourceWellLayerIngredient.ingredientStockIngredient;

  targetLayerIngredient.ingredientStockId = sourceWellLayerIngredient.ingredientStockId;
  targetLayerIngredient.ingredientStock = sourceWellLayerIngredient.ingredientStock;

  targetLayerIngredient.concentration = sourceWellLayerIngredient.concentration;
  targetLayerIngredient.preMixedConcentration =
    sourceWellLayerIngredient.preMixedConcentration;
  targetLayerIngredient.pH = sourceWellLayerIngredient.pH;

  targetLayerIngredient.highPhIngStockId = sourceWellLayerIngredient.highPhIngStockId;
  targetLayerIngredient.highPhIngStock = sourceWellLayerIngredient.highPhIngStock;

  targetLayerIngredient.stockConcentration = sourceWellLayerIngredient.stockConcentration;
  targetLayerIngredient.isBuffer = sourceWellLayerIngredient.isBuffer;
}

//ResetDirtyLayers
export function ResetDirtyLayers(docData, dirtyLayers) {
  for (const layerRow of dirtyLayers) {
    // if random layer is locked then we do not want to delete data as the same data
    // should be copied to another layer
    if (layerRow.Locked && layerRow.type == LayerType.Random) {
      continue;
    }
    for (const plate of docData.plateDto) {
      for (const well of plate.ingredients.wellList) {
        if (layerRow.targetDrop < 0) {
          const wellLayer = well.wellLayerList.find((wl) => wl.layerId == layerRow.id);
          if (wellLayer === undefined) {
            continue;
          }

          well.wellVolume -= wellLayer.volume;

          well.wellWaterVolume -= wellLayer.waterVolume;

          const wellLayerIndex = well.wellLayerList.indexOf(wellLayer);
          well.wellLayerList.splice(wellLayerIndex, 1);
        } else {
          const drop = well.dropList.find((d) => d.dropNumber == layerRow.targetDrop);
          const dropLayer = drop.dropLayerList.find((dl) => dl.layerId == layerRow.id);
          if (dropLayer === undefined) {
            continue;
          }

          drop.volume -= dropLayer.volume;
          drop.dropWellVolume -= dropLayer.dropWellVolume;
          drop.dropProteinVolume -= dropLayer.dropProteinVolume;

          const dropLayerIndex = drop.dropLayerList.indexOf(dropLayer);
          drop.dropLayerList.splice(dropLayerIndex, 1);
        }
      }
    }
  }
}
export function getWellById(wellId: number, docData: ExperimentDtoClient) {
  const wells = getExpWells(docData);
  const well = wells.find((w) => w.wellId === wellId);
  return well;
}
export function findWellsInLayer(
  plateVM: Plate[],
  layer: LayerDTO,
  containerNumRows: number,
  containerNumCols: number,
): WellIngDTO[][] {
  const layerHeight = layer.height;
  const layerWidth = layer.width;
  const layerRowX = layer.x;
  const layerRowY = layer.y;

  const layerWells: WellIngDTO[][] = new Array<Array<WellIngDTO>>();
  //[pltanum][wellnumber]
  const wellByPlateAndWellNumberCompositeKey: WellIngDTO[][] = [];

  for (let i = layerRowX; i <= layerWidth + layerRowX; i++) {
    for (let j = layerRowY; j <= layerHeight + layerRowY; j++) {
      const plate = GetPlate(
        plateVM,
        Math.floor(j / containerNumRows) + 1,
        Math.floor(i / containerNumCols) + 1,
      );
      const wellNumber = getWellNumber(
        containerNumCols,
        j % containerNumRows,
        i % containerNumCols,
      );
      const well: WellIngDTO = getWellUsingDict(
        plate,
        wellNumber,
        wellByPlateAndWellNumberCompositeKey,
      );
      if (layerWells[j - layerRowY] == undefined) {
        layerWells[j - layerRowY] = [];
      }

      layerWells[j - layerRowY][i - layerRowX] = well;
    }
  }

  return layerWells;
}

export function getWellAndPlateForConditionNumber(
  layer: LayerDTO,
  conditionNumber: number,
  containerNumRows: number,
  containerNumCols: number,
  plateVM: Plate[],
): { well: WellIngDTO; plate: Plate } | undefined {
  const layerWidth = layer.width + 1;
  const row = Math.floor((conditionNumber - 1) / layerWidth);
  const col = (conditionNumber - 1) % layerWidth;

  const wells = findWellsInLayer(plateVM, layer, containerNumRows, containerNumCols);
  const well = wells[row]?.[col];

  if (!well?.plateId) {
    return undefined;
  }

  const plate = plateVM.find((p) => p.plateId === well.plateId);
  if (!plate) {
    return undefined;
  }

  return { well, plate };
}

export function getWellNameForConditionNumber(
  layer: LayerDTO,
  conditionNumber: number,
  containerNumRows: number,
  containerNumCols: number,
  plateVM: Plate[],
): string | undefined {
  const result = getWellAndPlateForConditionNumber(
    layer,
    conditionNumber,
    containerNumRows,
    containerNumCols,
    plateVM,
  );

  if (!result?.well?.rowLetter || result.well.columnNumber == null) {
    return undefined;
  }

  return `Plate# ${result.plate.plateNumber} - Well# ${result.well.rowLetter}${result.well.columnNumber}`;
}

export function getWellNavigationDetailsForConditionNumber(
  layer: LayerDTO,
  conditionNumber: number,
  containerNumRows: number,
  containerNumCols: number,
  plateVM: Plate[],
): { wellNum: number; plateNum: number; plateID?: number } | undefined {
  const result = getWellAndPlateForConditionNumber(
    layer,
    conditionNumber,
    containerNumRows,
    containerNumCols,
    plateVM,
  );

  if (!result) {
    return undefined;
  }

  return {
    wellNum: result.well.wellNumber,
    plateNum: result.plate.plateNumber,
    plateID: result.plate.plateId,
  };
}

export function getConditionNumberForWell(
  layer: LayerDTO,
  wellNumber: number,
  plateNumber: number,
  containerNumRows: number,
  containerNumCols: number,
  plateVM: Plate[],
): number | undefined {
  const plate = plateVM.find((p) => p.plateNumber === plateNumber);
  if (!plate) {
    return undefined;
  }

  const wells = findWellsInLayer(plateVM, layer, containerNumRows, containerNumCols);
  const layerWidth = layer.width + 1;

  for (let row = 0; row < wells.length; row++) {
    const rowWells = wells[row];
    if (!rowWells) {
      continue;
    }

    for (let col = 0; col < rowWells.length; col++) {
      const well = rowWells[col];
      if (well?.wellNumber === wellNumber && well?.plateId === plate.plateId) {
        return row * layerWidth + col + 1;
      }
    }
  }

  return undefined;
}

export function findWellLayersInLayer(
  plates: Plate[],
  layer: LayerDTO,
  containerNumRows: number,
  containerNumCols: number,
): WellLayerDTO[][] {
  const layerWells: WellIngDTO[][] = findWellsInLayer(
    plates,
    layer,
    containerNumRows,
    containerNumCols,
  );

  const layerWellLayers = layerWells.map(function (wells: WellIngDTO[]) {
    return wells.map(function (well: WellIngDTO) {
      return well.wellLayerList.find((wl) => wl.layerId == layer.id);
    });
  });

  return layerWellLayers;
}

export function findWellDropsInLayer1d(
  plates: PlateDtoClient[],
  layer: LayerDTO,
): DropDTO[] {
  const layerDropLayers: DropDTO[] = [];
  plates.map((p) => {
    p.ingredients.wellList.map((wl) => {
      wl.dropList.map((drop) => {
        if (
          !isNullOrUndefined(drop.dropLayerList.find((dl) => dl.layerId === layer.id))
        ) {
          layerDropLayers.push(drop);
        }
      });
    });
  });
  return layerDropLayers;
}
export function findWellLayersInLayer1d(
  plates: PlateDtoClient[],
  layer: LayerDTO,
): WellLayerDTO[] {
  const layerWellLayers: WellLayerDTO[] = [];
  plates.map((p) => {
    p.ingredients.wellList.map((wl) => {
      wl.wellLayerList.map((wll) => {
        if (wll.layerId === layer.id) {
          layerWellLayers.push(wll);
        }
      });
    });
  });

  return layerWellLayers;
}

export function findWellsInLayer1d(
  plates: PlateDtoClient[],
  layer: LayerDTO,
): WellIngDTO[] {
  const wells: WellIngDTO[] = [];
  plates.map((p) => {
    p.ingredients.wellList.map((wl) => {
      const lyrWell = wl.wellLayerList.find((wll) => wll.layerId === layer.id);
      if (!isNullOrUndefined(lyrWell)) {
        wells.push(wl);
      }
    });
  });

  return wells;
}

export function getWellNumber(containerNumCols, wellY, wellX) {
  return containerNumCols * wellY + (wellX + 1);
}

export function getWell(plate: PlateDtoClient, wellNumber): WellIngDTO {
  const wellList: WellIngDTO[] = plate.ingredients.wellList;
  let targetWell: WellIngDTO;
  wellList.forEach((well) => {
    if (well.wellNumber == wellNumber) {
      targetWell = well;
      return;
    }
  });

  return targetWell;
}

export function getWellUsingDict(
  plate: PlateDtoClient,
  wellNumber,
  wellByPlateAndWellNumberCompositeKey: WellIngDTO[][],
): WellIngDTO {
  const wellList: WellIngDTO[] = plate.ingredients.wellList;
  if (wellByPlateAndWellNumberCompositeKey[plate.plateNumber]?.[wellNumber]) {
    return wellByPlateAndWellNumberCompositeKey[plate.plateNumber][wellNumber];
  }

  wellByPlateAndWellNumberCompositeKey[plate.plateNumber] = [];

  wellList.forEach((well) => {
    wellByPlateAndWellNumberCompositeKey[plate.plateNumber][well.wellNumber] = well;
  });

  return wellByPlateAndWellNumberCompositeKey[plate.plateNumber][wellNumber];
}

export function createLayer(
  layerName,
  targetDropNo,
  containerCols,
  containerRows,
  containerDefDropVolume,
) {
  let layer: LayerClient;

  layer.x = 0;
  layer.y = 0;
  layer.width = containerCols - 1;
  layer.height = containerRows - 1;
  layer.type = LayerType.Protein;
  layer.name = layerName;
  layer.targetDrop = targetDropNo;

  layer.wellDropVolumeVaryAlong = 1;
  layer.proteinDropVolumeVaryAlong = 1;

  layer.startWellDropVolume = containerDefDropVolume / 2.0;
  layer.stopWellDropVolume = containerDefDropVolume / 2.0;
  layer.startProteinDropVolume = containerDefDropVolume / 2.0;
  layer.stopProteinDropVolume = containerDefDropVolume / 2.0;

  return layer;
}

export function ComputeVaryAlong(
  layer,
  wellRowIndex,
  wellColIndex,
  start,
  stop,
  varyAlong,
) {
  let layerRowWidth;
  let layerRowHeight;

  switch (varyAlong) {
    case 1: //None
      return start;
    case 2: //Row
      layerRowWidth = layer.width;
      if (layerRowWidth == 1) {
        return start;
      }
      return start + ((stop - start) / (layerRowWidth - 1)) * wellColIndex;
    case 3: //Column
      layerRowHeight = layer.height;
      if (layerRowHeight == 1) {
        return start;
      }
      return start + ((stop - start) / (layerRowHeight - 1)) * wellRowIndex;
    case 5: //Well Number
      layerRowWidth = layer.width;
      layerRowHeight = layer.height;
      if (layerRowHeight * layerRowWidth == 1) {
        return start;
      }
      return (
        start +
        ((stop - start) / (layerRowHeight * layerRowWidth - 1)) *
          (wellColIndex * layerRowWidth + wellRowIndex)
      );
    default:
      throw new Error('Unknown grid vary encountered.');
  }
}

export function getExpWells(docData: ExperimentDtoClient): WellIng[] {
  const wells: WellIng[] = [];
  for (const plate of docData.plateDto) {
    wells.push(...plate.ingredients.wellList);
  }
  return wells;
}

export function findWellInLayer1D(
  plateVM: Plate[],
  layer: LayerDTO,
  containerNumRows: number,
  containerNumCols: number,
): WellIngDTO[] {
  const layerWells = findWellsInLayer(plateVM, layer, containerNumRows, containerNumCols);
  const targetWells: WellIngDTO[] = new Array<WellIngDTO>();
  for (let i = 0; i < layerWells.length; i++) {
    for (let j = 0; j < layerWells[i].length; j++) {
      targetWells.push(layerWells[i][j]);
    }
  }

  return targetWells;
}

export function createTargetWellDropLayer(layer: LayerDTO): WellDropLayer {
  const wellDropLayer: WellDropLayer = new WellDropLayer();

  wellDropLayer.layerId = layer.id;

  return wellDropLayer;
}

export function createTargetLayer(layer: LayerDTO, well: WellIngDTO): TargetLayer {
  const targetLayer: TargetLayer = new TargetLayer();
  targetLayer.layerId = layer.id;
  targetLayer.layer = layer;
  targetLayer.targetLayerIngredientList = [];
  return targetLayer;
}
export function CreateTargetLayerIngredient(
  targetLayer: TargetLayer,
): TargetLayerIngredient {
  const targetLayerIngredient = new TargetLayerIngredient();
  targetLayer.targetLayerIngredientList.push(targetLayerIngredient);
  targetLayerIngredient.ingredientTypeIsBuffer = false;
  targetLayerIngredient.ingredientTypeColorGroupId = 0;
  targetLayerIngredient.ingredientTypeId = 0;
  targetLayerIngredient.lowPHVolume = null;
  targetLayerIngredient.highPHVolume = null;
  return targetLayerIngredient;
}

export function generate(
  docData: ExperimentDtoClient,
  validateLayersOnly: boolean,
): boolean {
  let recomputeVolume = false;

  const dirtyLayers: LayerDTO[] = getDirtyLayers(docData);

  if (dirtyLayers.length > 0) {
    recomputeVolume = true;
    const filteredDirtyLayers = dirtyLayers.filter(
      (dl) => dl.type !== LayerTypeDTO.Random,
    );

    // When protein layers are dirty, also include all other protein layers targeting
    // the same drops so dropProteinVolume accumulates correctly across all proteins.
    const dirtyProteinDropNums = new Set(
      filteredDirtyLayers
        .filter((l) => l.type === LayerTypeDTO.Protein)
        .map((l) => l.targetDrop),
    );
    const extraProteinLayers =
      dirtyProteinDropNums.size > 0
        ? docData.layers.filter(
            (l) =>
              l.type === LayerTypeDTO.Protein &&
              !filteredDirtyLayers.includes(l) &&
              dirtyProteinDropNums.has(l.targetDrop),
          )
        : [];

    unGenerateLayers(docData, [...filteredDirtyLayers, ...extraProteinLayers]);
    generateLayers(docData, [...dirtyLayers, ...extraProteinLayers], recomputeVolume);
  }
  docData.plateDto.forEach((plate, index) => {
    setMaxVolume(plate.ingredients, plate.ingredients.containerMaxVolume);
  });

  if (dirtyLayers.length > 0 || recomputeVolume) {
    validateWellsAndDrops(
      docData.plateDto,
      docData.containerMaxDropVolume,
      docData.layers,
    );
  }

  computeIngColors(getExpWells(docData));
  docData.plateDto.forEach(
    (plate) => (plate.ingredients.wellList = [...plate.ingredients.wellList]),
  );
  return true;
}

function generateLayers(
  docData: ExperimentDtoClient,
  layerRows: LayerDTO[],
  recomputeVolumes: boolean,
) {
  const overrideLayers: LayerDTO[] = [];
  const nonOverrideLayers: LayerDTO[] = [];

  for (const layerRow of layerRows) {
    if (layerRow.overrideLayer) {
      overrideLayers.push(layerRow);
    } else {
      nonOverrideLayers.push(layerRow);
    }
  }

  generateNonOverrideLayers(docData, nonOverrideLayers);
  generateOverrideLayers(docData, overrideLayers);

  if (recomputeVolumes) {
    computeWellsVol(docData);
  }
  layerRows.map((l) => (l.dirty = false));
}

function getDirtyLayers(docData: ExperimentDtoClient): LayerDTO[] {
  const layers: LayerDTO[] = docData.layers.filter((l) => l.dirty == true);
  // mark dirty layer as modified
  layers.forEach((layer) => {
    if (layer.id < 0) {
      layer.layerState = LayerStateDTO.New;
    } else {
      layer.layerState = LayerStateDTO.Modified;
    }
  });
  return layers;
}

function removeSeedIdFromDrop(drop: Drop, lyr: LayerDTO) {
  const layerSeedId = (lyr.layerDetail as SeedLayerDTO)?.seedId;
  drop.seedIDs = (drop.seedIDs ?? []).filter((id) => id !== layerSeedId);
}

export function unGenerateLayers(docData: ExperimentDtoClient, dirtyLayers: LayerDTO[]) {
  for (const lyr of dirtyLayers) {
    // if random layer is locked then we do not want to delete data as the same data
    // should be copied to another layer
    if (lyr.locked && lyr.type == LayerTypeDTO.Random) {
      continue;
    }
    //can be optimized if get only those wells that were under the layer before change.
    const layerWells: WellIng[] = getExpWells(docData);
    for (const well of layerWells) {
      const wellLayer = well.wellLayerList.find((wl) => wl.layerId == lyr.id);
      if (wellLayer !== undefined) {
        well.wellVolume -= wellLayer.volume;
        well.wellWaterVolume -= wellLayer.waterVolume;
        spliceArrayElement(well.wellLayerList, wellLayer);
      }
      for (const drop of well.dropList) {
        const dropLayer = drop.dropLayerList.find((dl) => dl.layerId == lyr.id);
        if (dropLayer == undefined) {
          continue;
        }
        drop.volume =
          Number(drop.volume.toFixed(3)) - Number(dropLayer.volume.toFixed(3));
        drop.waterVolume -= dropLayer.waterVolume;

        switch (lyr.type) {
          case LayerTypeDTO.Protein: {
            const layerProteinFormulationIds = (
              (lyr.layerDetail as ProteinLayerDTO)?.proteinLayerProteinFormulation ?? []
            )
              .map((plPf) => plPf.proteinFormulationId)
              .filter((id): id is number => id != null);
            drop.proteinFormulationIDs = (drop.proteinFormulationIDs ?? []).filter(
              (id) => !layerProteinFormulationIds.includes(id),
            );
            if (
              drop.proteinFormulationID != null &&
              layerProteinFormulationIds.includes(drop.proteinFormulationID)
            ) {
              drop.proteinFormulationID = undefined;
            }
            drop.dropProteinVolume = 0;
            drop.dropWellVolume = 0;
            break;
          }
          case LayerTypeDTO.Seed: {
            removeSeedIdFromDrop(drop, lyr);
            drop.dropSeedVolume = Number(
              drop.dropLayerList
                .filter(
                  (dl) =>
                    dl !== dropLayer &&
                    docData.layers.find((l) => l.id === dl.layerId)?.type ===
                      LayerTypeDTO.Seed,
                )
                .reduce((sum, dl) => sum + dl.volume, 0)
                .toFixed(3),
            );
            break;
          }
          case LayerTypeDTO.Fragment:
            drop.dropFragmentVolume = 0;
            drop.isFragmentDrop = false;
            break;
          default:
            break;
        }
        spliceArrayElement(drop.dropLayerList, dropLayer);
      }
    }
  }
}

export function unGenerateLayer(docData: ExperimentDtoClient, lyr: LayerDTO) {
  // if random layer is locked then we do not want to delete data as the same data
  //can be optimized if get only those wells that were under the layer before change.
  const layerWells: WellIng[] = getExpWells(docData);
  for (const well of layerWells) {
    const wellLayer = well.wellLayerList.find((wl) => wl.layerId == lyr.id);
    if (wellLayer != undefined) {
      if (well.wellVolume - wellLayer.volume > 0) {
        well.wellVolume -= wellLayer.volume;
        well.wellWaterVolume -= wellLayer.waterVolume;
      } else {
        well.wellVolume = 0;
        well.wellWaterVolume = 0;
      }
      spliceArrayElement(well.wellLayerList, wellLayer);
    }
    for (const drop of well.dropList) {
      const dropLayer = drop.dropLayerList.find((dl) => dl.layerId == lyr.id);
      if (dropLayer == undefined) {
        continue;
      }
      drop.volume -= parseFloat(dropLayer.volume.toFixed(countDecimals(drop.volume)));
      drop.waterVolume -= parseFloat(
        dropLayer.waterVolume.toFixed(countDecimals(drop.waterVolume)),
      );

      if (lyr.type == LayerTypeDTO.Protein) {
        const layerProteinFormulationIds = (
          (lyr.layerDetail as ProteinLayerDTO)?.proteinLayerProteinFormulation ?? []
        )
          .map((plPf) => plPf.proteinFormulationId)
          .filter((id): id is number => id != null);
        drop.proteinFormulationIDs = (drop.proteinFormulationIDs ?? []).filter(
          (id) => !layerProteinFormulationIds.includes(id),
        );
        if (
          drop.proteinFormulationID != null &&
          layerProteinFormulationIds.includes(drop.proteinFormulationID)
        ) {
          drop.proteinFormulationID = undefined;
        }
        drop.dropProteinVolume = 0;
        drop.dropWellVolume = 0;
      } else if (lyr.type == LayerTypeDTO.Seed) {
        removeSeedIdFromDrop(drop, lyr);
        drop.dropSeedVolume = Number(
          drop.dropLayerList
            .filter(
              (dl) =>
                dl !== dropLayer &&
                docData.layers.find((l) => l.id === dl.layerId)?.type ===
                  LayerTypeDTO.Seed,
            )
            .reduce((sum, dl) => sum + dl.volume, 0)
            .toFixed(3),
        );
      } else if (lyr.type === LayerTypeDTO.Fragment) {
        drop.dropFragmentVolume = 0;
        drop.isFragmentDrop = false;
      }
      spliceArrayElement(drop.dropLayerList, dropLayer);
    }
  }
  validateWellsAndDrops(docData.plateDto, docData.containerMaxDropVolume, docData.layers);
}

export function RemoveWellIngredientsForOverrideLayer(
  docData: ExperimentDtoClient,
  layer: LayerDTO,
  well: WellIngDTO,
) {
  if (layer.overrideLayer) {
    for (const wellLayer of well.wellLayerList) {
      const wellLayerParentLayer = getLayer(docData, wellLayer.layerId);
      if (
        wellLayerParentLayer.type === LayerTypeDTO.Random &&
        wellLayerParentLayer.locked
      ) {
        return;
      }
      if (!wellLayerParentLayer.volumeBasedAddition) {
        for (const wellLayerIngredient of wellLayer.wellLayerIngredientList) {
          spliceArrayElement(wellLayer.wellLayerIngredientList, wellLayerIngredient);
        }

        spliceArrayElement(well.wellLayerList, wellLayer);
        wellLayer.volume = 0;
      }
    }
  }
}

export function spliceArrayElement(arr: any, element) {
  const index = arr.indexOf(element, 0);
  if (index > -1) {
    arr.splice(index, 1);
  }
}

function generateNonOverrideLayers(
  docData: ExperimentDtoClient,
  nonOverrideLayers: LayerDTO[],
) {
  if (nonOverrideLayers.length == 0) {
    return;
  }

  for (const layer of nonOverrideLayers) {
    switch (layer.type) {
      case LayerTypeDTO.ConditionList:
        CustomLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Fragment:
        FragmentLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Grid:
        GridLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Random:
        RandomLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Screen:
        ScreenLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Seed:
        SeedLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Protein:
        ProteinLayerGenerate(docData, layer);
        break;
      default:
        break;
    }
  }
}

function generateOverrideLayers(
  docData: ExperimentDtoClient,
  overrideLayers: LayerDTO[],
) {
  if (overrideLayers.length == 0) {
    return;
  }

  for (const layer of overrideLayers) {
    switch (layer.type) {
      case LayerTypeDTO.ConditionList:
        CustomLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Fragment:
        break;
      case LayerTypeDTO.Grid:
        GridLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Protein:
        break;
      case LayerTypeDTO.Screen:
        ScreenLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Random:
        RandomLayerGenerate(docData, layer);
        break;
      case LayerTypeDTO.Seed:
        break;
      default:
        break;
    }
  }
}

export function getIngIngType(ingIngTypeId: number) {
  return getIngredientIngredientTypeByIngIngTypeIdDict(ingIngTypeId);
}

export function validateWellsAndDrops(
  plates: Plate[],
  containerMaxDropVolume: number,
  layers: LayerDTO[],
) {
  plates.forEach((plate) => {
    if (!isNullOrUndefined(plate.ingredients)) {
      const errorsInWells = [];
      plate.ingredients.wellList.forEach((well) => {
        const erroneousWellLayers = getErroneusWellLayers(well);
        const erroneousDropLayers = getErroneusDropLayers(well);
        let errorFoundInWell = false;
        if (
          well.wellVolume > plate.ingredients.maxWellVolume ||
          erroneousWellLayers.length > 0 ||
          erroneousDropLayers.length > 0 ||
          well.wellWaterVolume < 0
        ) {
          let error = '';
          if (erroneousWellLayers.length > 0) {
            error = erroneousWellLayers[0].error;
          } else if (erroneousDropLayers.length > 0) {
            error = erroneousDropLayers[0].error;
          } else if (well.wellVolume > plate.ingredients.maxWellVolume) {
            error = 'Well volume is greater than maximum well volume.';
          } else if (well.wellWaterVolume < 0) {
            error = 'Well has invalid concentrations.';
          }

          well.hasError = true;
          well.error = error;
          errorsInWells.push(error);
          errorFoundInWell = true;
        } else {
          well.dropList.forEach((drop: Drop) => {
            let error = '';
            if (drop.volume > containerMaxDropVolume) {
              error = 'Drop' + ' has invalid volume/concentration.';
              well.hasError = true;
              well.error = error;
              errorsInWells.push(error);
              errorFoundInWell = true;
            } else if (layers && getFragmentLayersCountInDrop(drop, layers) > 1) {
              error = getMultipleFragmentLayersErrorMessage(drop.dropNumber);
              well.hasError = true;
              well.error = error;
              errorsInWells.push(error);
              errorFoundInWell = true;
            }
            if (drop.dropLayerList) {
              const fragmentLayers = layers.filter(
                (layer) => layer.type === LayerType.Fragment,
              );
              const fragmentLayerIds = fragmentLayers.map((fragment) => fragment.id);
              const dropFragmentLayers = drop.dropLayerList.filter((dropLayer) =>
                fragmentLayerIds.includes(dropLayer.layerId),
              );

              if (
                dropFragmentLayers?.length &&
                dropFragmentLayers[0].dropLayerFragmentList?.length
              ) {
                drop.isFragmentDrop = true;
              }
            }
          });
        }

        if (!errorFoundInWell) {
          well.hasError = false;
          well.error = '';
        }
      });
      if (errorsInWells.length > 0) {
        plate.ingredients.hasError = true;
        plate.ingredients.error = errorsInWells[0];
      } else {
        plate.ingredients.hasError = false;
        plate.ingredients.error = '';
      }
    }
  });
}

function validateFragmentLayer(layer: LayerDTO) {
  let errorDetails = { hasError: false, error: '', hasWarning: false, warning: '' };
  const fragmentLayer = layer.layerDetail as FragmentLayerDTO;

  if (!fragmentLayer?.fragmentScreen) {
    errorDetails = {
      hasError: true,
      error: 'Cannot save empty fragment layer!',
      hasWarning: false,
      warning: '',
    };
  }
  return errorDetails;
}

function validateScreenLayer(layer: LayerDTO) {
  let errorDetails = { hasError: false, error: '', hasWarning: false, warning: '' };
  const screenlayer = layer.layerDetail as ScreenLayerDTO;

  if (!isNullOrUndefined(screenlayer) && isNullOrUndefined(screenlayer.screenLot)) {
    errorDetails = {
      hasError: true,
      error: 'Cannot save empty screen layer!',
      hasWarning: false,
      warning: '',
    };
  }
  return errorDetails;
}
function validateProteinLayer(layer: LayerDTO) {
  let errorDetails = { hasError: false, error: '', hasWarning: false, warning: '' };
  const proteinLyr = layer.layerDetail as ProteinLayerDTO;

  if (
    !isNullOrUndefined(proteinLyr) &&
    !(
      proteinLyr.proteinLayerProteinFormulation !== undefined &&
      proteinLyr.proteinLayerProteinFormulation.length > 0 &&
      proteinLyr.proteinLayerProteinFormulation[0].proteinFormulationId !== undefined
    )
  ) {
    errorDetails = {
      hasError: true,
      error: 'Cannot save empty protein layer!',
      hasWarning: false,
      warning: '',
    };
  }
  return errorDetails;
}
function validateSeedLayer(layer: LayerDTO) {
  let errorDetails = { hasError: false, error: '', hasWarning: false, warning: '' };
  const seedLyr = layer.layerDetail as SeedLayerDTO;
  if (isNullOrUndefined(seedLyr) || isNullOrUndefined(seedLyr.seedId)) {
    errorDetails = {
      hasError: true,
      error: 'Cannot save empty seed layer!',
      hasWarning: false,
      warning: '',
    };
  }
  return errorDetails;
}
function validateRandomLayer(
  layer: LayerDTO,
  wellNums,
  plateDto: PlateDtoClient[],
  layers: LayerDTO[],
) {
  const errorDetails = { hasError: false, error: '', hasWarning: false, warning: '' };
  const randomLyr = layer.layerDetail as RandomLayerDTO;
  const randomLayers = layers.filter((l) => l.type === LayerTypeDTO.Random);
  let ingFound = false,
    groupFound = false;
  if (isNullOrUndefined(randomLyr)) {
    return errorDetails;
  }
  for (const ingGroup of randomLyr.randomLayerIngredientGroup) {
    if (ingGroup.randomLayerGenerationList.length > 0) {
      groupFound = true;
    }
    if (ingGroup.randomLayerGroupIngredient.length > 0) {
      ingFound = true;
    } else if (ingGroup.randomLayerGenerationList.length > 0) {
      ingFound = false;
      break;
    }
  }
  let totalCountofPopulatedWells = 0;
  let totalCountofPopulatedWellsForOverlapRandomLayers = 0;
  const overlapedRandomLayer = randomLayers.find(
    (l) => l.id !== layer.id && isOverlappingLayer(l, layer, false),
  );
  plateDto.forEach((plate) => {
    if (isNullOrUndefined(plate.ingredients)) {
      return null;
    }
    const wellContainingLayer: WellIngDTO[] = plate.ingredients.wellList.filter(
      (wl) => !isNullOrUndefined(wellNums.find((wn) => wn === wl.wellNumber)),
    );
    wellContainingLayer.forEach((wcl) => {
      wcl.wellLayerList.forEach((wll) => {
        if (overlapedRandomLayer && wll.layerId === overlapedRandomLayer?.id) {
          totalCountofPopulatedWellsForOverlapRandomLayers++;
        }
        if (wll.layerId === layer.id) {
          totalCountofPopulatedWells++;
        }
      });
    });
  });

  const wellsNotFullyUsed = totalCountofPopulatedWells < wellNums.length;
  const overlapException =
    layer.overrideLayer === false &&
    overlapedRandomLayer?.overrideLayer === true &&
    totalCountofPopulatedWellsForOverlapRandomLayers + totalCountofPopulatedWells >=
      wellNums.length;

  if (wellsNotFullyUsed && groupFound && ingFound && !overlapException) {
    errorDetails.hasWarning = true;
    errorDetails.warning =
      'Layer have been generated for this experiment. However, due to the low number of possible conditions, not all specified wells are being used.';
  }
  if (!ingFound && groupFound) {
    errorDetails.hasError = true;
    errorDetails.error =
      layer.name + ' (Generation List): The group has no ingredients.!';
  }
  return errorDetails;
}
export function GetWellNum(x, y, width, height, containerCols) {
  const wellNums = [];
  for (let i = y; i <= height + y; i++) {
    for (let j = x + 1; j <= width + x + 1; j++) {
      wellNums.push(i * containerCols + j);
    }
  }
  return wellNums;
}
export function saveAttemptedOnLyrs(layers: DrawingLayer[]) {
  for (const layer of layers) {
    (layer as DrawingLayer).isSaveAttempted = true;
  }
}
export function validate(experimentData: ExperimentDtoClient, validateForSave = false) {
  let errorDetails = [];
  const errors = [];

  for (const layer of experimentData.layers) {
    if (!layer.name || layer.name.trim() === '') {
      const errorMsg = 'Layer name cannot be empty.';
      if (!errors.some((e) => e.error === errorMsg)) {
        errors.push({
          hasError: true,
          error: errorMsg,
          hasWarning: false,
          warning: '',
        });
      }
    }

    const wellNums = GetWellNum(
      layer.x % experimentData.containerCols,
      layer.y,
      layer.width,
      layer.height,
      experimentData.containerCols,
    );
    errorDetails = findErrorsInLayer(experimentData, wellNums, layer, validateForSave);
    errorDetails.forEach((element) => {
      if (element.hasError && !errors.find((e) => e.error === element.error)) {
        errors.push(element);
      } else if (
        element.hasWarning &&
        !errors.find((e) => e.warning === element.warning)
      ) {
        errors.push(element);
      }
    });
  }

  let hasError = false;

  const getUniqueMessages = (
    arr: { error?: string; warning?: string }[],
    key: 'error' | 'warning',
  ) => {
    const valid = arr
      .map((e) => e[key])
      .filter((msg) => msg && msg.trim() !== '') as string[];
    const distinct = [...new Set(valid)];
    return distinct.filter(
      (msg, i, self) => !self.some((other, j) => j !== i && other.includes(msg)),
    );
  };

  let messages: string[] = [];

  if (errors.some((e) => e.hasError)) {
    hasError = true;
    messages = getUniqueMessages(
      errors.filter((e) => e.hasError),
      'error',
    );
  } else if (errors.some((e) => e.hasWarning)) {
    messages = getUniqueMessages(
      errors.filter((e) => e.hasWarning),
      'warning',
    );
  }

  const errorString = messages.join(' ');

  return { hasError, error: errorString };
}
export function findErrorsInLayer(docData, wellNums, layer, validateForSave = false) {
  const errorDetails = [];
  docData.plateDto.forEach((plate) => {
    if (isNullOrUndefined(plate.ingredients)) {
      return null;
    }
    if (!plate.ingredients.hasError) {
      return null;
    } else {
      const wellContainingLayer: WellIngDTO[] = plate.ingredients.wellList.filter(
        (wl) => !isNullOrUndefined(wellNums.find((wn) => wn === wl.wellNumber)),
      );
      wellContainingLayer.forEach((wcl) => {
        if (
          wcl.hasError &&
          (wcl.wellLayerList.find((wll) => wll.layerId === layer.id) ||
            wcl.dropList.find((dl) =>
              dl.dropLayerList.find((dll) => dll.layerId === layer.id),
            ))
        ) {
          if (!errorDetails.find((e) => e.error === wcl.error)) {
            errorDetails.push({
              hasError: true,
              error: wcl.error,
              hasWarning: false,
              warning: '',
            });
          }
          return null;
        }
      });
    }
  });
  let errorDetail;
  switch (layer.type) {
    case LayerTypeDTO.ConditionList:
      break;
    case LayerTypeDTO.Fragment:
      errorDetail = validateFragmentLayer(layer);
      if (
        errorDetail.hasWarning ||
        (errorDetail.hasError && (layer as DrawingLayer).isSaveAttempted)
      ) {
        errorDetails.push(errorDetail);
      }
      break;
    case LayerTypeDTO.Grid:
      break;
    case LayerTypeDTO.Random:
      errorDetail = validateRandomLayer(
        layer,
        wellNums,
        docData.plateDto,
        docData.layers,
      );
      if (
        errorDetail.hasWarning ||
        (errorDetail.hasError && (layer as DrawingLayer).isSaveAttempted)
      ) {
        errorDetails.push(errorDetail);
      }
      break;
    case LayerTypeDTO.Screen:
      errorDetail = validateScreenLayer(layer);
      if (
        errorDetail.hasWarning ||
        (errorDetail.hasError && (layer as DrawingLayer).isSaveAttempted)
      ) {
        errorDetails.push(errorDetail);
      }
      break;
    case LayerTypeDTO.Seed:
      errorDetail = validateSeedLayer(layer);
      if (
        errorDetail.hasWarning ||
        (errorDetail.hasError && (layer as DrawingLayer).isSaveAttempted)
      ) {
        errorDetails.push(errorDetail);
      }
      break;
    case LayerTypeDTO.Protein:
      errorDetail = validateProteinLayer(layer);
      if (
        errorDetail.hasWarning ||
        (errorDetail.hasError && (layer as DrawingLayer).isSaveAttempted)
      ) {
        errorDetails.push(errorDetail);
      }
      break;
    default:
      break;
  }
  return errorDetails;
}
export function IsBuffer(ingIngTypeId: number) {
  const _ingIngType = getIngredientIngredientTypeByIngIngTypeIdDict(ingIngTypeId);
  const _ingType = getIngredientTypeByIngTypeIdDict(_ingIngType.ingredientTypeId);
  if (_ingType) {
    return _ingType.isBuffer;
  }
  //fallback
  const ingsData = GetIngredients();
  const ingIngType: IngredientIngredientTypeDTO = ingsData.ingredientIngredientType.find(
    (ingIngTyp) => ingIngTyp.id == ingIngTypeId,
  );
  const ingType = ingsData.ingredientType.find(
    (ingType) => ingType.id == ingIngType.ingredientTypeId,
  );
  return ingType.isBuffer;
}

export function IsStockBuffer(ingStockId: number): boolean {
  const ingStock = getIngStock(ingStockId);
  return ingStock.isBuffer;
}
export function getIngStock(ingStockId: number): IngredientStockDTO {
  const ingsData = GetIngredients();
  const ingStock: IngredientStockDTO = ingsData.ingredientStock.find(
    (ingStock) => ingStock.id == ingStockId,
  );
  return ingStock;
}

export function getIngredient(ingId: number): IngredientDTO {
  const ingsData = GetIngredients();
  const ing: IngredientDTO = ingsData.ingredients.find((ing) => ing.id == ingId);
  return ing;
}

export function getIngredientType(ingTypeId: number): IngredientTypeDTO {
  return getIngredientTypeByIngTypeIdDict(ingTypeId);
}

export function updateWellByTargetLayer(
  layer: LayerDTO,
  targetLayer: TargetLayer,
  well: WellIngDTO,
) {
  const wellLayer: WellLayerDTO = getWellLayer(targetLayer, well);
  well.wellLayerList.push(wellLayer);
}
export function updateDropByTargetLayer(
  layer: LayerDTO,
  targetLayer: TargetLayer,
  well: WellIngDTO,
): DropDTO | undefined {
  const drop: DropDTO = getDrop(well, layer);
  if (drop === undefined) {
    return undefined;
  }

  const dropLayer: DropLayerDTO = getDropLayer(targetLayer, drop);
  drop.dropLayerList.push(dropLayer);

  return drop;
}
export function newDrop(well: WellIngDTO, layer: LayerDTO): DropDTO {
  if (well.dropList === undefined) {
    well.dropList = [];
  }
  const drop = new DropDTO();
  drop.dropId = getNewId();
  drop.dropNumber = layer.targetDrop;
  drop.proteinFormulationID = null;
  drop.dropWellVolume = 0;
  drop.dropProteinVolume = 0;
  drop.volume = 0;
  drop.waterVolume = 0;
  drop.dropSeedVolume = 0;
  drop.dropFragmentVolume = 0;
  drop.dropLayerList = [];
  well.dropList.push(drop);
  return drop;
}

export function getDrop(well: WellIngDTO, layer: LayerDTO): DropDTO {
  const drop: DropDTO = well.dropList.find((d) => d.dropNumber === layer.targetDrop);
  return drop;
}
function getWellLayer(targetLayer: TargetLayer, well: WellIngDTO): WellLayerDTO {
  const wellLayer: WellLayerDTO = new WellLayerDTO();

  wellLayer.wellId = well.wellId;
  wellLayer.id = getNewId();
  wellLayer.layerId = targetLayer.layerId;
  wellLayer.volume = targetLayer.volume;
  wellLayer.waterVolume = targetLayer.waterVolume;
  wellLayer.sourceWellId =
    targetLayer.sourceWellId == undefined ? null : targetLayer.sourceWellId;
  wellLayer.waterSource = null;
  wellLayer.sourceWellConditionNumber =
    targetLayer.sourceWellConditionNumber == undefined
      ? null
      : targetLayer.sourceWellConditionNumber;
  wellLayer.hasError = targetLayer.hasError;
  wellLayer.error = targetLayer.error;
  wellLayer.wellLayerIngredientList = getWellLayerLayerIngList(
    targetLayer.targetLayerIngredientList,
    wellLayer,
  );

  return wellLayer;
}

function getWellLayerLayerIngList(
  targetLayerIngredientList: TargetLayerIngredient[],
  wellLayer: WellLayerDTO,
): WellLayerIngredientDTO[] {
  const wellLayerIngs: WellLayerIngredientDTO[] = [];
  for (const targetLyrIng of targetLayerIngredientList) {
    wellLayerIngs.push(getWellLayerLayerIng(targetLyrIng));
  }
  return wellLayerIngs;
}

function getWellLayerLayerIng(targetLyrIng: TargetLayerIngredient) {
  const wellLyrIng: WellLayerIngredientDTO = new WellLayerIngredientDTO();
  wellLyrIng.volume = targetLyrIng.volume;

  wellLyrIng.color = targetLyrIng.color;
  wellLyrIng.hexColor = targetLyrIng.hexColor;
  wellLyrIng.lowPHVolume = targetLyrIng.lowPHVolume;
  wellLyrIng.highPHVolume = targetLyrIng.highPHVolume;

  wellLyrIng.ingredientIngredientTypeId = targetLyrIng.ingredientIngredientTypeId;
  wellLyrIng.ingredientStockIngredient = targetLyrIng.ingredientStockIngredient;

  wellLyrIng.ingredientStockId = targetLyrIng.ingredientStockId;
  wellLyrIng.ingredientStock = targetLyrIng.ingredientStock;

  wellLyrIng.concentration = targetLyrIng.concentration;
  wellLyrIng.preMixedConcentration = targetLyrIng.preMixedConcentration;
  wellLyrIng.pH = targetLyrIng.pH;

  wellLyrIng.highPhIngStockId = targetLyrIng.highPhIngStockId;
  wellLyrIng.highPhIngStock = targetLyrIng.highPhIngStock;

  wellLyrIng.stockConcentration = targetLyrIng.stockConcentration;
  //--Todo - probably one isBuffer would be enough.
  wellLyrIng.isBuffer = targetLyrIng.isBuffer;
  wellLyrIng.ingredientIngredientTypeIsBuffer =
    targetLyrIng.ingredientIngredientTypeIsBuffer;
  wellLyrIng.ingredientTypeIsBuffer = targetLyrIng.ingredientTypeIsBuffer;

  wellLyrIng.ingredientTypeColorGroupId = targetLyrIng.ingredientTypeColorGroupId;
  wellLyrIng.ingredientTypeId = targetLyrIng.ingredientTypeId;

  wellLyrIng.ingredientTypeName = targetLyrIng.ingredientTypeName;

  return wellLyrIng;
}

function getDropLayer(targetLayer: TargetLayer, drop: DropDTO): DropLayerDTO {
  const dropLayer: DropLayerDTO = new DropLayerDTO();

  dropLayer.dropId = drop.dropId;
  dropLayer.id = getNewId();

  dropLayer.layerId = targetLayer.layerId;
  dropLayer.volume = targetLayer.volume;
  dropLayer.waterVolume = targetLayer.waterVolume;
  dropLayer.sourceWellId =
    targetLayer.sourceWellId == undefined ? null : targetLayer.sourceWellId;
  dropLayer.waterSource = null;
  dropLayer.dropLayerFragmentList = [];
  dropLayer.hasError = targetLayer.hasError;
  dropLayer.error = targetLayer.error;
  dropLayer.dropLayerIngredientList = getWellLayerLayerIngList(
    targetLayer.targetLayerIngredientList,
    undefined,
  );

  dropLayer.layer = targetLayer.layer;
  return dropLayer;
}

export function getLayer(docData: ExperimentDtoClient, layerId: number): LayerDTO {
  return docData.layers.find((l) => l.id == layerId);
}

export function getProteinLayersCountInDrop(drop: Drop, layers: LayerDTO[]): number {
  let proteinLayerCount = 0;

  drop.dropLayerList.forEach((dl) => {
    const layer = layers.find((lyr) => lyr.id === dl.layerId);
    if (layer?.type === LayerType.Protein) {
      proteinLayerCount++;
    }
  });

  return proteinLayerCount;
}

export function getSeedLayersCountInDrop(drop: Drop, layers: LayerDTO[]): number {
  let seedLayerCount = 0;

  drop.dropLayerList.forEach((dl) => {
    const layer = layers.find((lyr) => lyr.id === dl.layerId);
    if (layer?.type === LayerType.Seed) {
      seedLayerCount++;
    }
  });

  return seedLayerCount;
}

export function getFragmentLayersCountInDrop(drop: Drop, layers: LayerDTO[]): number {
  let layerCount = 0;

  drop.dropLayerList.forEach((dl) => {
    const layer = layers.find((lyr) => lyr.id === dl.layerId);
    if (layer?.type === LayerType.Fragment) {
      layerCount++;
    }
  });

  return layerCount;
}

export function getMultipleFragmentLayersErrorMessage(dropNumber: number): string {
  return `Multiple Fragment Layers found in Drop ${dropNumber}.`;
}

export function isFragmentLayerAlreadyInDrop(
  exp: ExperimentDtoClient,
  layer: LayerDTO,
  dropNumber: number,
): boolean {
  const wells = findWellsInLayer(
    exp.plateDto,
    layer,
    exp.containerRows,
    exp.containerCols,
  );

  return wells.some((wellRow) =>
    wellRow.some((well) => {
      const drop = well?.dropList?.find((d) => d.dropNumber === dropNumber);
      return !!drop && getFragmentLayersCountInDrop(drop as Drop, exp.layers) > 0;
    }),
  );
}

export function getErroneusWellLayers(well: WellIng): WellLayer[] {
  const erroneousWellLayers: WellLayer[] = [];
  erroneousWellLayers.push(...well.wellLayerList.filter((wl) => wl.hasError === true));
  return erroneousWellLayers;
}

export function getErroneusDropLayers(well: WellIng): DropLayer[] {
  const erroneousDropLayers: DropLayer[] = [];
  for (const d of well.dropList) {
    const errDropLyrs = d.dropLayerList.filter((wl) => wl.hasError === true);
    erroneousDropLayers.push(...errDropLyrs);
  }
  return erroneousDropLayers;
}

export function computeIngColors(wells: WellIng[]) {
  for (const well of wells) {
    const ingredientTypeCount = new Map<number, number>();
    well.wellLayerList = well.wellLayerList.sort((wl1, wl2) => wl2.id - wl1.id);
    for (const wellLayer of well.wellLayerList) {
      wellLayer.wellLayerIngredientList = wellLayer.wellLayerIngredientList.sort(
        (wli1, wli2) => wli1.id - wli2.id,
      );
      for (const wellLayerIng of wellLayer.wellLayerIngredientList) {
        const globalIngTypeColors = GetIngredientTypeColors();
        const ingredientTypeGroupColorRows: IngredientTypeColor[] =
          globalIngTypeColors.filter(
            (ingTypeColor) =>
              ingTypeColor.groupId == wellLayerIng.ingredientTypeColorGroupId,
          );

        if (!ingredientTypeCount.has(wellLayerIng.ingredientTypeId)) {
          ingredientTypeCount.set(wellLayerIng.ingredientTypeId, 0);
        }
        let val = ingredientTypeCount.get(wellLayerIng.ingredientTypeId);
        val = (val % 3) + 1;
        const colorGroup = ingredientTypeGroupColorRows.find(
          (ing) =>
            ing.groupId === wellLayerIng.ingredientTypeColorGroupId &&
            ing.colorToneSequence === val,
        );
        wellLayerIng.color = colorGroup.color;
        wellLayerIng.hexColor = getHexColor(wellLayerIng.color);
        ingredientTypeCount.set(wellLayerIng.ingredientTypeId, val);
      }
    }
  }
}
